import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './asset/css/custom.css';
import './asset/css/animate.min.css';
import './asset/css/fontawesome.css';

import "react-datepicker/dist/react-datepicker.css";
import {Provider} from "react-redux";
import store from "./store";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
                <App/>
      </Provider>
  </React.StrictMode>
);
